import React, { useEffect, useState } from "react";
import { FiEdit } from "react-icons/fi";
import Swal from "sweetalert2";
import "./CommissionManage.css";

const API_BASE = process.env.REACT_APP_API_URL || "http://localhost:5000";
const API = `${API_BASE}/admin/commissions`;
const SETTINGS_API = `${API_BASE}/admin/commissions/count-settings`;
const REQUESTS_API = `${API_BASE}/hotels/limit-increase-requests`;
const BONUS_API = `${API_BASE}/admin/referral-bonus`;

export function Status({ status, small = false }) {
  const isApproved = status === "Approved";
  const isRejected = status === "Inactive" || status === "Suspended" || status === "Rejected";
  const clsColor = isApproved ? "green" : isRejected ? "red" : "amber";
  const cls = `badge ${clsColor}`;
  const displayStatus = isRejected ? "Rejected" : status;
  const style = small
    ? {
      padding: "6px 12px",
      fontSize: 12,
      borderRadius: 12,
      display: "inline-block",
    }
    : { padding: "6px 12px", borderRadius: 14, display: "inline-block" };
  return (
    <span className={cls} style={{ ...style }}>
      {displayStatus}
    </span>
  );
}

const getCategoryDisplayName = (category) => {
  const baseName = category.replace(/_/g, " ");
  switch (category) {
    case "Regular_booking (Hotel) - Full PayHere":
      return `${baseName} [Hotel Owner Account - Historical PayHere]`;
    case "Regular_booking (Hotel) - Full Payments.lk":
      return `${baseName} [Hotel Owner Account - Payments.lk]`;
    case "Regular_booking(Guide) - Full PayHere":
      return `${baseName} [Guide Account - Historical PayHere]`;
    case "Regular_booking(Guide) - Full Payments.lk":
      return `${baseName} [Guide Account - Payments.lk]`;
    case "agent_booking(Hotel)":
      return `${baseName} [Agent Account]`;
    case "agent_booking(Guide)":
      return `${baseName} [Agent Account]`;
    case "agent_booking(Agent)":
      return `${baseName} [Agent Account]`;
    case "Regular_booking (Hotel) - Advance PayHere":
      return `${baseName} [Hotel Account - Historical PayHere]`;
    case "Regular_booking (Hotel) - Advance Payments.lk":
      return `${baseName} [Hotel Account - Payments.lk]`;
    case "Regular_booking (Guide) - Advance PayHere":
      return `${baseName} [Guide Account - Historical PayHere]`;
    case "Regular_booking (Guide) - Advance Payments.lk":
      return `${baseName} [Guide Account - Payments.lk]`;
    case "Regular_booking (Hotel)- Full KOKO":
      return `${baseName} [Hotel Account - Koko BNPL]`;
    case "Regular_booking (Guide) - Advance  KOKO":
      return `${baseName} [Guide Account - Koko BNPL]`;
    case "event_booking (Event) - PayHere":
      return `${baseName} [Event Organizer Account - Historical PayHere]`;
    case "event_booking (Event) - Payments.lk":
      return `${baseName} [Event Organizer Account - Payments.lk]`;
    case "event_booking (Event) - KOKO":
      return `${baseName} [Event Organizer Account - Koko BNPL]`;
    case "event_booking":
      return `${baseName} [Event Organizer Account]`;
    default:
      return baseName;
  }
};

export default function CommissionManagement() {
  const [commissions, setCommissions] = useState([]);
  const [settings, setSettings] = useState([]);
  const [requests, setRequests] = useState([]);
  const [bonus, setBonus] = useState({ bonus_amount: 10 });

  const fetchCommissions = async () => {
    try {
      const res = await fetch(API);
      const data = await res.json();
      setCommissions(data);
    } catch (err) {
      console.error(err);
      Swal.fire("Error", "Failed to load commissions", "error");
    }
  };

  const fetchSettings = async () => {
    try {
      const res = await fetch(SETTINGS_API);
      const data = await res.json();
      setSettings(data);
    } catch (err) {
      console.error(err);
      Swal.fire("Error", "Failed to load count settings", "error");
    }
  };

  // New fetch for requests
  const fetchRequests = async () => {
    try {
      const res = await fetch(REQUESTS_API);
      const data = await res.json();
      setRequests(data);
    } catch (err) {
      console.error(err);
      Swal.fire("Error", "Failed to load limit increase requests", "error");
    }
  };

  const fetchBonus = async () => {
    try {
      const res = await fetch(BONUS_API);
      const data = await res.json();
      setBonus(data);
    } catch (err) {
      Swal.fire("Error", "Failed to load referral bonus", "error");
    }
  };

  useEffect(() => {
    fetchCommissions();
    fetchSettings();
    fetchRequests();
    fetchBonus();
  }, []);

  // Handle status toggle
  // const handleToggleStatus = async (id, currentStatus) => {
  //   try {
  //     const res = await fetch(
  //       `${REQUESTS_API.replace(
  //         "limit-increase-requests",
  //         `limit-increase-request/${id}/status`
  //       )}`,
  //       {
  //         method: "PUT",
  //       }
  //     );

  //     const data = await res.json();
  //     if (!res.ok) throw new Error(data.error || "Failed to update status");

  //     Swal.fire({
  //       title: "Success!",
  //       text: `${currentStatus} request updated successfully.`,
  //       icon: "success",
  //       timer: 1200,
  //       showConfirmButton: false,
  //     });

  //     fetchRequests();
  //   } catch (err) {
  //     Swal.fire("Error", err.message, "error");
  //   }
  // };

  // Handle commission update
  const handleUpdate = async (category, oldValue) => {
    const { value: newPercent } = await Swal.fire({
      title: `Update ${category.replace("_", " ")} Commission`,
      input: "number",
      inputValue: oldValue,
      inputAttributes: { min: 0, max: 100, step: 0.5 },
      confirmButtonText: "Update",
      showCancelButton: true,
      customClass: {
        confirmButton: "custom-swal-confirm",
        cancelButton: "custom-swal-cancel",
      },
      inputValidator: (value) => {
        if (!value || isNaN(value) || value < 0 || value > 100) {
          return "Enter a valid percentage between 0 and 100";
        }
      },
    });

    if (!newPercent) return;

    try {
      const res = await fetch(`${API}/${category}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ percentage: parseFloat(newPercent) }),
      });

      const data = await res.json();
      if (!res.ok) throw new Error(data.message);

      Swal.fire({
        title: "Updated!",
        text: `${category.replace("_", " ")} set to ${newPercent}%`,
        icon: "success",
        timer: 1200,
        showConfirmButton: false,
      });
      fetchCommissions();
    } catch (err) {
      Swal.fire("Error", err.message, "error");
    }
  };

  // Handle limits update
  const handleUpdateLimits = async (category, oldValue) => {
    const { value: newCount } = await Swal.fire({
      title: `Update ${category.replace("_", " ")}`,
      input: "number",
      inputValue: oldValue,
      inputAttributes: { min: 0, max: 100, step: 1 },
      confirmButtonText: "Update",
      showCancelButton: true,
      customClass: {
        confirmButton: "custom-swal-confirm",
        cancelButton: "custom-swal-cancel",
      },
      inputValidator: (value) => {
        if (!value || isNaN(value) || value < 0 || value > 100) {
          return "Enter a valid count between 0 and 100";
        }
      },
    });

    if (!newCount) return;

    try {
      const res = await fetch(`${SETTINGS_API}/${category}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ count: newCount }),
      });

      const data = await res.json();
      if (!res.ok) throw new Error(data.message);

      Swal.fire({
        title: "Updated!",
        text: `${category.replace("_", " ")} set to ${newCount} turns`,
        icon: "success",
        timer: 1200,
        showConfirmButton: false,
      });
      fetchSettings();
    } catch (err) {
      Swal.fire("Error", err.message, "error");
    }
  };

  // Handle increasing user limit from requests
  const handleIncreaseUserLimit = async (request) => {
    const { user_id, username, id, category, role, listing_count } = request;
    if (!user_id) {
      return Swal.fire("Error", "User ID missing!", "error");
    }

    const limitCategory = category || (
      role?.toLowerCase().includes("hotel")
        ? (role?.toLowerCase().includes("agent") ? "agent_hotel" : "hotel_listing")
        : (role?.toLowerCase().includes("agent") ? "agent_guide" : "guide_listing")
    );

    const { value: newLimit } = await Swal.fire({
      title: `Set New Limit for ${username}`,
      html: `
        <div style="text-align: left; font-size: 14px; margin-bottom: 12px; color: #475569;">
          <p style="margin: 4px 0;"><strong>Role:</strong> ${role || "User"}</p>
          <p style="margin: 4px 0;"><strong>Current Count:</strong> ${listing_count ?? 0}</p>
        </div>
      `,
      input: "number",
      inputValue: (listing_count || 0) + 2,
      inputAttributes: { min: 1, max: 200, step: 1 },
      showCancelButton: true,
      confirmButtonText: "Approve & Set Limit",
      confirmButtonColor: "#10b981",
      customClass: {
        confirmButton: "custom-swal-confirm",
        cancelButton: "custom-swal-cancel",
      },
      inputValidator: (value) => {
        if (!value || isNaN(value) || parseInt(value) < 1) {
          return "Enter a valid limit greater than 0";
        }
      },
    });

    if (!newLimit) return;

    try {
      const res = await fetch(
        `${API_BASE}/admin/commissions/custom-limit/${user_id}`,
        {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            limit_count: parseInt(newLimit),
            category: limitCategory,
            request_id: id,
          }),
        }
      );

      const data = await res.json();
      if (!res.ok) throw new Error(data.error || "Failed to update user limit");

      Swal.fire({
        title: "Success",
        text: `Limit updated to ${newLimit} and request approved!`,
        icon: "success",
        timer: 1500,
        showConfirmButton: false,
      });

      // Refresh requests table
      fetchRequests();
    } catch (err) {
      Swal.fire({
        title: "Error",
        text: err.message,
        icon: "error",
      });
    }
  };

  const handleRejectRequest = async (id, username) => {
    const result = await Swal.fire({
      title: "Reject Request?",
      text: `Are you sure you want to reject the limit increase request for ${username}?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, Reject",
      confirmButtonColor: "#ef4444",
      cancelButtonText: "Cancel",
    });

    if (!result.isConfirmed) return;

    try {
      const res = await fetch(`${API_BASE}/hotels/limit-increase-request/${id}/status`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ status_id: 6 }), // 6 = Inactive / Rejected
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error || "Failed to reject request");

      Swal.fire({
        title: "Rejected",
        text: "Limit increase request has been rejected.",
        icon: "success",
        timer: 1200,
        showConfirmButton: false,
      });

      fetchRequests();
    } catch (err) {
      Swal.fire("Error", err.message, "error");
    }
  };

  const handleUpdateBonus = async () => {
    const { value: newBonus } = await Swal.fire({
      title: "Update Referral Bonus",
      input: "number",
      inputValue: bonus?.bonus_amount ?? 10,
      inputAttributes: { min: 0, step: 0.5 },
      showCancelButton: true,
      confirmButtonText: "Update",
      customClass: {
        confirmButton: "custom-swal-confirm",
        cancelButton: "custom-swal-cancel",
      },
      inputValidator: (value) => {
        if (!value || value < 0) return "Enter a valid bonus amount";
      },
    });

    if (!newBonus) return;

    try {
      const res = await fetch(BONUS_API, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ bonus_amount: parseFloat(newBonus) }),
      });

      const data = await res.json();
      if (!res.ok) throw new Error(data.error);

      Swal.fire({
        title: "Updated!",
        text: "Referral Bonus Updated!",
        icon: "success",
        timer: 1200,
        showConfirmButton: false,
      });
      fetchBonus();
    } catch (err) {
      Swal.fire("Error", err.message, "error");
    }
  };

  return (
    <div className="wd-page">
      <div className="wd-head">
        <h2 className="wd-title">Commissions, Bonus & Limits Management</h2>
      </div>

      {/* Commission Table */}
      <section className="card commission-card">
        <div className="flex-between">
          <h3 className="wd-subtitle">Commissions</h3>
        </div>
        <table className="table">
          <thead>
            <tr>
              <th>Category</th>
              <th>Current Percentage</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {commissions.map((c) => (
              <tr key={c.id}>
                <td style={{ textTransform: "capitalize" }}>
                  {getCategoryDisplayName(c.category)}
                </td>
                <td style={{ fontWeight: "bold" }}>{c.percentage}%</td>
                <td>
                  <FiEdit
                    style={{
                      cursor: "pointer",
                      color: "#3b82f6",
                      marginRight: 12,
                    }}
                    size={18}
                    onClick={() => handleUpdate(c.category, c.percentage)}
                    title="Update commission"
                  />
                  {/* <button
                    className="btn blue"
                    onClick={() => handleUpdate(c.category, c.percentage)}
                  >
                    Update
                  </button> */}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {commissions.length === 0 && (
          <p className="dots">No commission data found.</p>
        )}
      </section>

      {/* Referral Bonus Table */}
      <section className="card commission-card" style={{ marginTop: 30 }}>
        <div className="flex-between">
          <h3 className="wd-subtitle">Referral Bonus Settings</h3>
        </div>

        <table className="table">
          <thead>
            <tr>
              <th>Bonus Type</th>
              <th>Current Amount</th>
              <th>Action</th>
            </tr>
          </thead>

          <tbody>
            <tr>
              <td>Referral Reward</td>
              <td style={{ fontWeight: "bold" }}>{bonus?.bonus_amount ?? 0} Coins</td>
              <td>
                <FiEdit
                  style={{
                    cursor: "pointer",
                    color: "#3b82f6",
                    marginRight: 12,
                  }}
                  size={18}
                  onClick={handleUpdateBonus}
                  title="Update bonus"
                />
              </td>
            </tr>
          </tbody>
        </table>
      </section>

      {/* Listing and registration count Table */}
      <section className="card commission-card" style={{ marginTop: 30 }}>
        <div className="flex-between">
          <h3 className="wd-subtitle">Listing & Registration Limits</h3>
        </div>
        <table className="table">
          <thead>
            <tr>
              <th>Limit Category</th>
              <th>Current Count</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {settings.map((c) => (
              <tr key={c.id}>
                <td style={{ textTransform: "capitalize" }}>
                  {c.category.replace("_", " ")}
                </td>
                <td style={{ fontWeight: "bold" }}>{c.count} turns</td>
                <td>
                  <FiEdit
                    style={{
                      cursor: "pointer",
                      color: "#3b82f6",
                      marginRight: 12,
                    }}
                    size={18}
                    onClick={() => handleUpdateLimits(c.category, c.count)}
                    title="Update limits"
                  />
                  {/* <button
                    className="btn blue"
                    onClick={() => handleUpdate(c.category, c.percentage)}
                  >
                    Update
                  </button> */}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {settings.length === 0 && <p className="dots">No count data found.</p>}
      </section>

      {/* Limit Increase Requests */}
      <section className="card commission-card" style={{ marginTop: 30 }}>
        <div className="flex-between">
          <h3 className="wd-subtitle">Listing & Registration Limit Increase Requests</h3>
        </div>
        <table className="table">
          <thead>
            <tr>
              <th>Username</th>
              <th>Role</th>
              <th>Email Address</th>
              <th>Request Reason</th>
              <th>Current Count</th>
              <th>Assign New Limit</th>
              <th>Status</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {requests.map((r) => {
              const isPending = r.status === "Pending" || r.status_id === 3;
              const roleName = r.role || "User";
              const isAgentRole = roleName.toLowerCase().includes("agent");
              const roleBadgeStyle = isAgentRole 
                ? { background: "#f3e8ff", color: "#7e22ce", padding: "4px 10px", borderRadius: "12px", fontSize: "12px", fontWeight: "700" }
                : roleName.toLowerCase().includes("hotel")
                ? { background: "#e0efff", color: "#1e40af", padding: "4px 10px", borderRadius: "12px", fontSize: "12px", fontWeight: "700" }
                : { background: "#ecfdf5", color: "#047857", padding: "4px 10px", borderRadius: "12px", fontSize: "12px", fontWeight: "700" };

              return (
                <tr key={r.id}>
                  <td style={{ fontWeight: "600" }}>{r.username}</td>
                  <td>
                    <span style={roleBadgeStyle}>{roleName}</span>
                  </td>
                  <td>{r.email}</td>
                  <td style={{ maxWidth: "250px", wordBreak: "break-word" }}>{r.request}</td>
                  <td style={{ fontWeight: "bold" }}>{r.listing_count}</td>
                  <td>
                    <button
                      onClick={() => handleIncreaseUserLimit(r)}
                      style={{
                        background: "#10b981",
                        color: "#fff",
                        border: "none",
                        padding: "6px 12px",
                        borderRadius: "6px",
                        cursor: "pointer",
                        fontSize: "13px",
                        fontWeight: "600",
                        display: "flex",
                        alignItems: "center",
                        gap: "5px"
                      }}
                      title="Assign Limit & Approve"
                    >
                      <FiEdit size={14} /> Assign Limit
                    </button>
                  </td>
                  <td>
                    <Status status={r.status} />
                  </td>
                  <td>
                    {isPending ? (
                      <button
                        onClick={() => handleRejectRequest(r.id, r.username)}
                        style={{
                          background: "#fee2e2",
                          color: "#b91c1c",
                          border: "1px solid #fca5a5",
                          padding: "5px 10px",
                          borderRadius: "6px",
                          cursor: "pointer",
                          fontSize: "12px",
                          fontWeight: "600"
                        }}
                        title="Reject Request"
                      >
                        Reject
                      </button>
                    ) : (
                      <span style={{ color: "#9ca3af", fontSize: "12px" }}>Completed</span>
                    )}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
        {requests.length === 0 && (
          <p className="dots">No limit increase requests found.</p>
        )}
      </section>
    </div>
  );
}
